import { IUserApprovalActiveProcess } from "@/UI/Interfaces/IFavorite";
import { get, post } from "@/Utils/axios";

export function requestGetUserRights(): any {
  return get(`Configuration/GetHRUserRights`);
}

export function requestGetHomeUserSpecificData(): any {
  return get(`HumanResource/GetHrHomeUserSpecificData`);
}

export function requestGetAllTodayActivity(): any {
  return get(`Configuration/GetAllTodayActivity`);
}

export function requestSetObjectFavorite(objectcontrollerno: string, applicationobjecttype: string): any {
  return get(`screen/SetObjectFavorite`, { params: { objectcontrollerno, applicationobjecttype } });
}

export function requestGetUserApprovalActiveProcess(): IUserApprovalActiveProcess[] {
  return get(`Configuration/GetUserApprovalActiveProcess`) as any;
}

export function requestMarkUserAttendance(data: any): any {
  return post("HumanResource/UserAttendanceMark", data);
}

export function requestGetSelfServiceData(data: any): any {
  return post("HumanResource/GetSelfServiceData", data);
}